import apiRequest from "./apiClient";

export async function fetchDefectGallery(activeOnly = false, productCategoryId) {
  const params = new URLSearchParams();
  if (activeOnly && productCategoryId) {
    params.set("productCategoryId", productCategoryId);
  }
  const path = activeOnly
    ? `/api/v1/admin/defect-images/active${params.toString() ? `?${params}` : ""}`
    : "/api/v1/admin/defect-images";
  const body = await apiRequest(path);
  return body.data || [];
}

export async function createDefectGalleryImage(payload) {
  const body = await apiRequest("/api/v1/admin/defect-images", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return body.data;
}

export async function updateDefectGalleryImage(id, payload) {
  const body = await apiRequest(`/api/v1/admin/defect-images/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
  return body.data;
}

export async function fetchGalleryLinkedDefectCount(id) {
  const body = await apiRequest(`/api/v1/admin/defect-images/${id}/linked-defects`);
  return body.data ?? 0;
}

export async function deleteDefectGalleryImage(id) {
  const body = await apiRequest(`/api/v1/admin/defect-images/${id}`, { method: "DELETE" });
  return body.data;
}
